import { useState, useMemo } from "react";
import { userFullName } from "helpers/common";
import downArrow from "Assets/images/downArrowPurple.png"
import upArrow from "Assets/images/upArrowPurple.png"
import downArrowNormal from "Assets/images/downArrowBlack.png"
import { store } from "store/store";
import { DeleteIcon } from "Assets/icons";
import { CommonToolTip } from "components/Common/Common";
import NoRecordAddDetails from "components/NoRecordAddDetails";
import UpArrowIcon from "Assets/images/UpArrowIcon";
import DownArrowIcon from "Assets/images/DownArrowIcon";
import { useRemoveTherapistMutation } from "store/services/clientCaseLoads";
import confirmDialogV2 from "utils/confirmationDialogV2";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { Button } from "react-bootstrap";
import AssignApprenticePop from "components/Modals/AssignApprenticePop";
import { useDeleteApprenticeMutation } from "store/services/apprentice";

const CliniciansAssignedComponent = ({ onClick, clientDetails, setCurrentEntry, setShowDeleteModal, isDisabled = false, refetch }) => {

    const state = store.getState();
    const user = state.auth.user;

    const [sortField, setSortField] = useState("name");  // "name" | "discipline"
    const [sortOrder, setSortOrder] = useState("asc");   // "asc" | "desc"
    const [showAddApprenticeModal, setShowAddApprenticeModal] = useState(false);
    const [therapistCaseloadId, setTherapistCaseloadId] = useState(null);
    const [therapistId, setTherapistId] = useState(null)
    const [currentApprenticeId, setCurrentApprenticeId] = useState(null);
    const [disciplineId, setDisciplineId] = useState(null)

    const [removeTherapist, { isLoading: removeTherapistLoading }] = useRemoveTherapistMutation();
    const [deleteApprentice, { isLoading: deleteLoading }] = useDeleteApprenticeMutation()

    const handleSort = (field) => {
        if (sortField === field) {
            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        } else {
            setSortField(field);
            setSortOrder("asc");
        }
    };

    // // Flatten the nested mapping first
    // const formattedData = useMemo(() => {
    //     const list =
    //         clientDetails?.clientCaseloads?.clientCaseloadTherapist
    //             ?.flatMap(item =>
    //                 item?.clientCaseloadMapping
    //                     ?.filter(x => x?.caseTherapist?.therapist_detail?.type === "veteran")
    //                     ?.map(caseloadMapping => ({
    //                         name: userFullName(caseloadMapping?.caseTherapist),
    //                         discipline: item?.caseDiscipline?.assign_term,
    //                         raw: { item, caseloadMapping }
    //                     }))
    //             ) || [];

    //     return list;
    // }, [clientDetails]);

    const formattedData = useMemo(() => {
        return (
            clientDetails?.clientCaseloads
                // Only the regular caseload belongs on the client detail page; MDT caseloads are managed on the MDT screens
                ?.filter(caseload => caseload?.case_type === "regular")
                ?.flatMap(caseload =>
                    caseload?.clientCaseloadTherapist
                        ?.flatMap(item =>
                            item?.clientCaseloadMapping
                                ?.filter(
                                    x =>
                                        x?.caseTherapist?.therapist_detail?.type === "veteran"
                                )
                                ?.map(caseloadMapping => ({
                                    name: userFullName(caseloadMapping?.caseTherapist),
                                    discipline: item?.caseDiscipline?.assign_term,
                                    id: item?.id,
                                    raw: { caseload, item, caseloadMapping }
                                }))
                        )
                ) || []
        );
    }, [clientDetails]);


    console.log('formattedData', formattedData)

    // Sorting logic
    const sortedData = useMemo(() => {
        return [...formattedData].sort((a, b) => {
            let A = "", B = "";

            if (sortField === "name") {
                A = a.name?.toLowerCase() || "";
                B = b.name?.toLowerCase() || "";
            }

            if (sortField === "discipline") {
                A = a.discipline?.toLowerCase() || "";
                B = b.discipline?.toLowerCase() || "";
            }

            if (sortOrder === "asc") return A > B ? 1 : -1;
            return A < B ? 1 : -1;
        });
    }, [formattedData, sortField, sortOrder]);

    const handleRemoveTherapist = async (e, currentEntry) => {

        e.stopPropagation();
        const isConfirm = await confirmDialogV2({
            title: `REMOVE THERAPIST?`,
            message: `Are you sure you want to remove this therapist?`,
        });
        if (!isConfirm) {
            return
        }

        try {
            const result = await removeTherapist(currentEntry?.id);
            if (result?.error) return;

            // refetch();
            if (typeof refetch === "function") {
                refetch();
            }
            // setShowDeleteModal(false);
            successMessageToast(result?.data?.message);
        } catch (err) {
            console.error("Error removing Therapist", err);
        }
    };

    const handleDeleteApprentice = async (e,caseloadId, therapistId, currentApprenticeId) => {
        e.stopPropagation();
        const isConfirm = await confirmDialogV2({
            title: `REMOVE APPRENTICE?`,
            message: `Are you sure you want to remove this apprentice?`,
        });
        if (!isConfirm) {
            return
        }
        try {
            // setShowDeleteApprenModal(false)
            const resp = await deleteApprentice({ caseloadId, currentApprenticeId, therapistId }).unwrap()
            if (resp.status === "success") {
                successMessageToast(resp?.message)
            }

        } catch (error) {
            console.error(error);
        }
        refetch()
    }

    return (
        <>
            <AssignApprenticePop
                show={showAddApprenticeModal}
                setShow={setShowAddApprenticeModal}
                caseloadId={therapistCaseloadId}
                refetch={refetch}
                currentApprenticeId={currentApprenticeId}
                disciplineId={disciplineId}
                therapistId={therapistId}
            />
            {(removeTherapistLoading || deleteLoading) && <LoadingOverlay />}
            <div className="mt-2">
                <table className="w-100">
                    <thead>
                        <tr>
                            <th
                                onClick={() => handleSort("name")}
                                className={`fw-medium ten cursor-pointer ${sortField === "name" && "themeBlueV2"}`}
                                style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}
                            >
                                NAME
                                <span className="ms-2">
                                    {sortField === "name" ? (sortOrder === "asc" ? <UpArrowIcon color={sortOrder === "asc"} /> : <DownArrowIcon color={sortOrder === "desc"} />) : <DownArrowIcon />}
                                </span>
                                {/* <img
                                width={9}
                                height={9}
                                className="ms-2"
                                src={
                                    sortField === "name"
                                        ? sortOrder === "asc" ? upArrow : downArrow
                                        : downArrowNormal
                                }
                                alt="downArrow"
                            /> */}
                            </th>

                            <th
                                onClick={() => handleSort("discipline")}
                                className={`fw-medium ten text-end cursor-pointer ${sortField === "discipline" && "themeBlueV2"}`}
                                style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}
                            >
                                DISCIPLINE
                                <span className="ms-2">
                                    {sortField === "discipline" ? (sortOrder === "asc" ? <UpArrowIcon color={sortOrder === "asc"} /> : <DownArrowIcon color={sortOrder === "desc"} />) : <DownArrowIcon />}
                                </span>
                                {/* <img
                                width={9}
                                height={9}
                                className="ms-2"
                                src={
                                    sortField === "discipline"
                                        ? sortOrder === "asc" ? upArrow : downArrow
                                        : downArrowNormal
                                }
                                alt="downArrow"
                            /> */}
                            </th>
                            {
                                !isDisabled && <th
                                    // onClick={() => handleSort("discipline")}
                                    className={`fw-medium w-10 text-end cursor-pointer ${sortField === "discipline" && ""}`}
                                    style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}
                                >
                                </th>
                            }

                        </tr>
                    </thead>

                    <tbody>
                        {sortedData?.length > 0 ? (
                            sortedData.map((row, index) => {
                                const { item, caseloadMapping } = row.raw;
                                console.log('row', row)
                                const apprenticeFound = item.clientCaseloadMapping.find(
                                    x => x?.caseTherapist?.therapist_detail?.type === "apprentice"
                                );

                                console.log('caseloadMapping', caseloadMapping)

                                // const veteranFound = item.clientCaseloadMapping.find(
                                //     x => x?.caseTherapist?.therapist_detail?.type === "veteran"
                                // );

                                // const isVeteranUser = user?.role_type === "veteran";
                                // const isDischarged =
                                //     item?.caseServiceStatus?.title?.toLowerCase() === "discharge";

                                return <>
                                    <tr key={index}>
                                        <td className="proxima" style={{ fontSize: "12px", color: "#000", padding: "15px 10px", borderBottom: !apprenticeFound && "1px solid #8F8F8F", borderRadius: 0 }}>
                                            {row.name}
                                        </td>
                                        <td className="text-end proxima" style={{ color: "#000", fontSize: "12px", padding: "15px 10px", borderBottom: !apprenticeFound && "1px solid #8F8F8F", borderRadius: 0 }}>
                                            <span
                                                className={`discipline-${row.discipline}-capsule-bcg`}
                                                style={{ padding: "7px 10px", marginRight: "3px", borderRadius: "8px" }}
                                            >
                                                {row.discipline}
                                            </span>
                                        </td>
                                        {
                                            !isDisabled && <td className="text-end proxima" style={{ color: "#000", fontSize: "12px", padding: "15px 10px", borderBottom: !apprenticeFound && "1px solid #8F8F8F", borderRadius: 0 }}>
                                                <CommonToolTip
                                                    text={"Remove Clinician"}
                                                    component={
                                                        <DeleteIcon
                                                            className="cursor-pointer"
                                                            onClick={(e) => {
                                                                // setCurrentEntry(row);
                                                                handleRemoveTherapist(e, row)
                                                                // setShowDeleteModal(true)
                                                            }}
                                                        />
                                                    }
                                                />
                                            </td>
                                        }
                                    </tr>
                                    {
                                        <tr>
                                            {apprenticeFound && (
                                                <td style={{ borderBottom: "1px solid #8F8F8F", padding: "0px 0px" }} colSpan={3}>
                                                    <div className="align-items-center">
                                                        <div className="d-flex align-items-center justify-content-between">
                                                            <p style={{ paddingLeft: "10px", }}><span style={{ fontWeight: "600" }}>Apprentice: </span> {userFullName(apprenticeFound?.caseTherapist)}</p>
                                                            {
                                                                (clientDetails?.client_detail?.client_type == 'chatter' || clientDetails?.client_detail?.client_type == 'school')  &&
                                                                <div className="d-flex gap-2">
                                                                    <Button
                                                                        style={{ height: "30px", minWidth: "40px", fontSize: "12px" }}
                                                                        // disabled={clientDetails?.status != 'active'}
                                                                        disabled={['active', 'incoming']?.includes(clientDetails?.status) ? false : true}
                                                                        onClick={() => {
                                                                            setTherapistCaseloadId(item.id);
                                                                            setCurrentApprenticeId(apprenticeFound.therapist_id);
                                                                            setDisciplineId(item?.discipline_id);
                                                                            setTherapistId(caseloadMapping?.therapist_id)
                                                                            setShowAddApprenticeModal(true);
                                                                        }}
                                                                        className="commonBtn"
                                                                    >
                                                                        Change
                                                                    </Button>
                                                                    <Button
                                                                        style={{ height: "30px", minWidth: "40px", fontSize: "12px" }}
                                                                        // disabled={clientDetails?.status != 'active'}
                                                                        disabled={['active', 'incoming']?.includes(clientDetails?.status) ? false : true}
                                                                        onClick={(e) => {
                                                                            // setTherapistCaseloadId(item.id);
                                                                            // setCurrentApprenticeId(apprenticeFound.therapist_id);
                                                                            // setShowDeleteApprenModal(true);
                                                                            handleDeleteApprentice(e,item?.id, caseloadMapping?.therapist_id, apprenticeFound.therapist_id)
                                                                        }}
                                                                        className="commonBtn"
                                                                    >
                                                                        Remove
                                                                    </Button>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </td>
                                            )}
                                            {/* Assign Apprentice */}
                                            {
                                                (!apprenticeFound) && (clientDetails?.client_detail?.client_type == 'chatter' || clientDetails?.client_detail?.client_type == 'school') && (
                                                    <td style={{ padding: "15px 10px", borderBottom: "1px solid #8F8F8F", borderRadius: 0 }} colSpan={3} className="">
                                                        <div className="d-flex ">
                                                            <Button
                                                                style={{ height: "30px", minWidth: "40px", fontSize: "12px" }}
                                                                // disabled={isDischarged}
                                                                onClick={() => {
                                                                    setTherapistCaseloadId(item.id);
                                                                    setCurrentApprenticeId(null);
                                                                    setDisciplineId(item?.discipline_id);
                                                                    setTherapistId(caseloadMapping?.therapist_id)
                                                                    setShowAddApprenticeModal(true);

                                                                }}
                                                                className="commonBtn"
                                                            >
                                                                Assign Apprentice
                                                            </Button>
                                                        </div>
                                                    </td>
                                                )
                                            }
                                        </tr>
                                    }
                                </>

                            })
                        ) : (
                            <tr>
                                <td colSpan="3" className="text-center px-0">
                                    <NoRecordAddDetails onClick={onClick} title='Add a clinician' />
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default CliniciansAssignedComponent;
